<template>
    <modal :id="id" :loading="loading" :saveing="saveing" @shown="shown" @ok="save" @cancel="cancel">
        <span slot="modal-title">項目</span>
        <!--<div class="row" v-if="vm.Type==='5-1'">
            <div class="col-md-2 col-sm-12">
                <form-input v-model="vm.SYear" id="SYear" label="學年度" disabled></form-input>
            </div>
            <div class="col-md-4 col-sm-12">
                <form-input v-model="vm.Value" id="Value" label="核評內容" disabled></form-input>
            </div>
            <div class="col-md-2 col-sm-12">
                <label>條件1</label>
                <label class="form-control">
                    <label>
                        <input type="checkbox" v-model="vm.MinEqual" value="true" />
                        ><span v-if="vm.MinEqual">=</span>
                    </label>
                </label>
            </div>
            <div class="col-md-2 col-sm-12">
                <form-input v-model="vm.Min" id="Min" label="條件2" type="number" required></form-input>
            </div>
            <div class="col-md-2 col-sm-12">
                <form-input v-model="vm.Score" id="Score" label="點數" type="number" required></form-input>
            </div>
        </div>-->
        <div class="row">
            <div class="col-md-2 col-sm-12">
                <form-input v-model="vm.SYear" id="SYear" label="學年度" disabled></form-input>
            </div>
            <div class="col-md-4 col-sm-12">
                <form-input v-model="vm.Value" id="Value" label="項目" disabled></form-input>
            </div>
            <div class="col-md-2 col-sm-12">
                <form-input value="每次" label="條件" disabled></form-input>
            </div>
            <div class="col-md-4 col-sm-12">
                <form-input v-model="vm.Score" id="Score" label="點數" type="number" required></form-input>
            </div>
        </div>
    </modal>
</template>

<script>
    import { detail } from '@/views';
    export default detail({
        name: 'pasetDetail',
        api: '/api/g1paset/',
    });
</script>

<style>
</style>